import React, { useEffect, useRef, useState, FC } from "react";
import { Button, message } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { getFormValidatorErrText } from "@/utils/utils"
import { useSaleRoDetailModel } from "./saleRoDetailModel";
import { globalPrompt } from "@/components/message";
import { useGlobalModel, transOptions, getFindItem } from "@/model/globalModel";
import { useDictModel } from "../../../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import { DetailType } from "@/types/ScmEnums";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

interface ITopType {
    id: string,
    mode: "add" | "edit" | "look",
    IYhFormRef: React.MutableRefObject<IYhFormRef | undefined>
}
export const FormBox: FC<ITopType> = ({ id, mode, IYhFormRef }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, CustomerData } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { detailEditForm, detailAddForm, detailLookForm, updateAddFormVal, updatEditFormVal, getDetailEditOne, resetCatch, resetAddCatch, resetEditCatch } = useSaleRoDetailModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    useEffect(() => {

        if (!Object.keys(detailEditForm).length && mode == DetailType.edit) {
            getDetailEditOne(id, mode)
        }
        mode == DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])
    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("2-4-1") && resetAddCatch(mode);
            !findNav("2-4-2") && resetEditCatch(mode);
        }
    }, [selectedNavId])
    const goCustomer = () => {
        replaceNav(
            selectedNavId,
            "13-5-1-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }
    const baseFormItem: IYhFormItemsBox = {
        // title: "基础信息",
        title: Locale["Basic Info"],
        style: { padding: "18px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="statu-blue" onClick={goCustomer}>{Locale["Customer"]}</span>,
                fieldName: "customerCode",
                options: transOptions(CustomerData),
                showSearch: true,
                // rules: [{ required: true, message: "请选择客户" }],
                rules: [{ required: true, message: Locale["This item is Required"] }],
                disable: mode != "add" ? true : false
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系人",
                fieldLabel: Locale["Contact"],
                fieldName: "contact",
                // rules: [{ required: true, message: "该项为必填" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系电话",
                fieldLabel: Locale["Contact Number"],
                fieldName: "phone",
                // rules: [{ required: true, message: "该项为必填" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]

            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: '结算类型',
                fieldLabel: Locale["Payment Type"],
                fieldName: "payType",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE),
                // rules: [{ required: true, message: "请选择结算类型" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "制单时间",
                fieldLabel: Locale["Creation Time"],
                fieldName: "createTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "退货原因",
                fieldLabel: Locale["Return Reason"],
                fieldName: "returnReason",
                // }, {
                //     type: FormItemTypeEnum.TreeSelect,
                //     fieldLabel: "客户类型",
                //     fieldName: "customerTypeCode",
                //     treeData: getTreeSelectOne(DictCodeEnmu.CUSTOMER_TYPE),
                //     rules: [{ required: true, message: "请选择客户类型" }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note",
                span: 12,
                labelCol: { span: 3 },
            }
        ]
    };

    const onChange = (changedValues: { [key: string]: any }) => {
        if (mode == DetailType.add) {
            updateAddFormVal(changedValues)
        } else if (mode == DetailType.edit) {
            updatEditFormVal(changedValues)
        }

    }
    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    const poFromConfig: IYhFormBox = {
        formRef: IYhFormRef,
        labelCol: { span: 6 },
        disabled: mode == DetailType.look,
        labelAlign: "right",
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}